import { render, staticRenderFns } from "./ReportOrdersLabelsModal.vue?vue&type=template&id=3d4841e8&scoped=true&"
import script from "./ReportOrdersLabelsModal.vue?vue&type=script&lang=js&"
export * from "./ReportOrdersLabelsModal.vue?vue&type=script&lang=js&"
import style0 from "./ReportOrdersLabelsModal.vue?vue&type=style&index=0&id=3d4841e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4841e8",
  null
  
)

export default component.exports